<template>
  <div>
    <div class="pt-6 lg:pb-0 lg:pl-6 xl:pl-6 md:pl-6">
      <div class="hidden lg:flex flex-wrap w-full p-4">
        <div class="not-italic font-normal text-zt-xl leading-8 flex items-center text-zt-primary-200">
          {{ $t('message.UploadLanding.pageTitle') }}
        </div>
      </div>
      <div class="flex flex-wrap w-full p-4">
        <v-card class="rounded w-full desktop-width">

          <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-full mt-4">
            <div class="h-32">
              <graphic-base height="100%" width="100%" :viewBox="'0 0 301 200'">
                <upload-file-svg />
              </graphic-base>
            </div>
          </div>
          <div class="w-full px-10 md:px-32">
            <div class="mx-auto my-2 md:my-10 not-italic font-medium text-zt-xl leading-6 items-center text-center text-zt-dark-500">{{ $t('message.UploadLanding.uploadFile.title') }}</div>
            <div class="mx-auto md:h-20 not-italic font-normal text-zt-s leading-4 items-center text-center text-zt-dark-300">
              {{ $t('message.UploadLanding.uploadFile.description') }}
            </div>
          </div>
          <div class="w-full flex my-4 md:my-10">
            <zt-button :disabled="isIdDisabled" class="mx-auto" @click="$router.push('uploadfile')">{{ $t('message.UploadLanding.uploadFile.button') }}</zt-button>
          </div>
        </v-card>
        <v-card class="rounded w-full desktop-width md:mx-auto" :class="windowSize.width < 1024 ? 'mt-4' : ''">
          <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-full mt-4">
            <div class="h-32">
              <graphic-base height="100%" width="100%" :viewBox="'0 0 301 187'">
                <pickup-svg />
              </graphic-base>
            </div>
          </div>
          <div class="w-full px-10 md:px-32">
            <div class="mx-auto my-2 md:my-10 not-italic font-medium text-zt-xl leading-6 items-center text-center text-zt-dark-500">{{ $t('message.UploadLanding.pickup.title') }}</div>
            <div class="mx-auto md:h-20 not-italic font-normal text-zt-s leading-4 items-center text-center text-zt-dark-300">
              {{ $t('message.UploadLanding.pickup.description') }}
            </div>
          </div>
          <div class="w-full flex my-4 md:my-10">
            <zt-button class="mx-auto" @click="$router.push('pickup')">{{ $t('message.UploadLanding.pickup.button') }}</zt-button>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import ZtHeader from '@/components/Header'
import ZtMenu from '@/components/MenuBar'
import graphicBase from '../components/commons/Illustrations/graphicBase'
import uploadFileSvg from '../components/commons/Illustrations/graphicSVG/graphicUploadFile'
import pickupSvg from '../components/commons/Illustrations/graphicSVG/graphicPickup'
import { useWindowResize } from '@sichern/ui-elements' 

export default {
  name: 'Upload',
  components: {
    ZtHeader,
    ZtMenu,
    graphicBase,
    uploadFileSvg,
    pickupSvg
  },
  data() {
    return {
      windowSize: useWindowResize(this),
      disabledCompaniesIds: [2731]
    }
  },
  computed: {
    isIdDisabled() {
      const companyId = this.$store.state.user.perfiles[0].idempresa
      return this.disabledCompaniesIds.includes(companyId);
    }
  }
}
</script>

<style lang="scss" scoped>

@media (min-width: 900px) {  
  .desktop-width {
    width: 49%;
  }
}

</style>